/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { useResizer } from '@/hooks';

import {
  BlocCreation,
  BlocListe,
  BlocStatistiques,
  BlocSynthetique,
} from './Blocs';

const Dashboard = () => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const [, setLoadingSynthetique] = React.useState<boolean>(false);
  useResizer(width, setWidth);

  const renderMobileScreen = React.useMemo(
    () => (
      <div
        style={{
          height: '100%',
          overflowY: 'auto',
          padding: '1em',
          gap: '1em',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <BlocCreation />
        <BlocSynthetique setLoading={setLoadingSynthetique} />
        <BlocStatistiques />
        <BlocListe />
      </div>
    ),
    [],
  );

  const renderDesktopScreen = React.useMemo(
    () => (
      <div
        style={{
          height: '100%',
          display: 'flex',
          gap: '1em',
          padding: '1em',
          overflowY: 'auto',
        }}
      >
        <div
          style={{
            flex: 6,
            display: 'flex',
            flexDirection: 'column',
            gap: '1em',
          }}
        >
          <BlocCreation style={{ margin: 0, minHeight: 300, maxHeight: 300 }} />
          <BlocListe style={{ margin: 0, flex: 1 }} />
        </div>
        <div
          style={{
            flex: 10,
            display: 'flex',
            flexDirection: 'column',
            gap: '1em',
          }}
        >
          <BlocSynthetique
            style={{ margin: 0, height: 300 }}
            setLoading={setLoadingSynthetique}
          />
          <BlocStatistiques style={{ margin: 0, flex: 1 }} />
        </div>
      </div>
    ),
    [],
  );
  if (width < 1200) return renderMobileScreen;

  return renderDesktopScreen;
};

export default Dashboard;
